import LoadingScreen from "./LoadingScreen";
import SessionRecovery from "./SessionRecovery";
import { useContext } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { canAccessTenantRoute, isTenantPath } from './tenantAccess';
export default function TenantAccessBoundary({ children }) {
 const auth=useContext(AuthContext); const location=useLocation();
 if (!isTenantPath(location.pathname)) return children;
 if (auth.loading) return <LoadingScreen fullScreen />;
 if (!auth.user && auth.authError) return <SessionRecovery />;
 if (!auth.user) return <Navigate to="/login" replace />;
 if (canAccessTenantRoute(location.pathname,auth)) return children;
 const home=auth.user.type==='STUDENT'?'/studentdashboard':auth.user.type==='CLIENT'?'/clientdashboard':auth.user.type==='PARTNER'?'/partnerdashboard':'/admindashboard';
 return <main className="flex min-h-screen items-center justify-center bg-primary text-secondary"><div className="max-w-md p-8 text-center"><h1 className="text-2xl font-semibold">Access unavailable</h1><p className="my-4">Your account does not have access to this page. Contact your owner if you need access.</p><Link className="text-accent underline" to={home}>Go to your home page</Link></div></main>;
}

